export const SET_SYSTEM_TITLE = 'SYSTEM_TITLE';
export const SET_VALUES = 'SYSTEM_SET_VALUES';
export const SET_INITIAL_VALUES = 'SYSTEM_SET_INITIAL_VALUES';

export const setSystemTitle = (title) => ({ type: SET_SYSTEM_TITLE, title });
export const setValues = (values) => ({ type: SET_VALUES, values });
export const setInitialValues = () => ({ type: SET_INITIAL_VALUES });
